import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
export function useInViewport(ref) {
  const $ = _c(6);
  const [isInViewport, setIsInViewport] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isInViewport || $[1] !== ref) {
    t0 = () => {
      if (ref.current && !isInViewport) {
        const observer = new IntersectionObserver(t2 => {
          const [entry] = t2;
          return entry.isIntersecting && setIsInViewport(true);
        });
        observer.observe(ref.current);
        return () => {
          observer.disconnect();
        };
      }
    };
    t1 = [isInViewport, ref];
    $[0] = isInViewport;
    $[1] = ref;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== isInViewport) {
    t2 = {
      isInViewport
    };
    $[4] = isInViewport;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}